import type { LiveFiber } from '@use-gpu/live';
import { makeContext, useContext, useFiber, useNoContext } from '@use-gpu/live';
import { TimeContext } from './time-provider';
import { ViewFrameContext } from './view-frame-provider';

export type LoopContextProps = (fiber?: LiveFiber<any>) => void;

export const LoopContext = makeContext<LoopContextProps>(() => {}, 'LoopContext');

export const useAnimationFrame   = () => useContext(LoopContext)(useFiber());
export const useNoAnimationFrame = () => useNoContext(LoopContext);

export const usePerFrame   = () => { return useContext(ViewFrameContext) + useContext(TimeContext).frame; }
export const useNoPerFrame = () => { useNoContext(ViewFrameContext); useNoContext(TimeContext); }
